import { render } from "./BasicModal.vue?vue&type=template&id=d28bca4a&scoped=true&ts=true"
import script from "./BasicModal.vue?vue&type=script&lang=ts"
export * from "./BasicModal.vue?vue&type=script&lang=ts"

import "./BasicModal.vue?vue&type=style&index=0&id=d28bca4a&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28bca4a"]])

export default __exports__